import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {cloneDeep, debounce, filter, get} from 'lodash';
import {toast} from 'react-toastify';

import filtersUtil from '../../utils/filters';
import {copyTextToClipboard, implode} from '../../utils/utils';
import constants from '../../constants';
import {history} from '../../store/configureStore';

import {
  fetchActivities,
  fetchCacheActivities,
  fetchOpenActivities,
  fetchRewards,
  resetActivitiesError,
  showActivityLinkCopiedSnackbar,
} from '../../actions/funActions';

import {
  fetchLocalities,
  hideGeoLocationLoading,
  resetLocalitiesData,
  showGeoLocationLoading,
} from '../../actions/locationAction';

import {cacheListData, fetchHelp, resetCacheListData} from '../../actions/appActions';
import Space from "../commons/Space";
import Typography from "@material-ui/core/Typography";
import {
  ColorBackground,
  ColorBackgroundXS,
  ColorCard,
  ColorCardFieldHover,
  ColorCardFieldSelected,
  ColorCardXS,
  ColorField,
  ColorOrange,
  ColorSubTitle,
  ColorTitle,
  ColorTitleLite,
  ColorWhite
} from "src/styles/Colors";
import {Button, Paper} from "@material-ui/core";
import {
  baseStyles,
  BORDER_RADIUS,
  BOTTOM_BAR_HEIGHT,
  BOTTOM_BAR_HEIGHT_XS,
  CARD_SPACING,
  changeBodyColor,
  CONTENT_MAX_WIDTH_PLAY,
  DRAWER_WIDTH,
  FIELD_SPACE,
  FONT_WEIGHT_MEDIUM,
  IS_BOTTOM_TAB_PRESENT,
  TOOLBAR_HEIGHT,
  TOOLBAR_HEIGHT_XS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import HeaderTitleView from "../commons/HeaderTitleView";
import DialogView from "../commons/DialogView";
import TextView from "../commons/TextView";
import ActivityHelper from "../../utils/ActivityHelper";
import ButtonBase from "@material-ui/core/ButtonBase";
import LocationHelper, {LOCATION_TIMEOUT} from "../../utils/LocationHelper";
import {FontWeightMedium} from "src/res/FontWeight";
import CircularProgress from "@material-ui/core/CircularProgress";
import PathHelper from "../../utils/PathHelper";
import {HELP_ENABLE_LOCATION_AR_URL, HELP_ENABLE_LOCATION_URL} from "../../utils/services";
import {VariableSizeGrid} from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import {logDebug} from "../../utils/AppLog";
import AppInstall from "../commons/AppInstall";
import {FETCH_CACHE_FUN_ACTIVITIES} from "../../constants/actionTypes";
import AppText from "../commons/AppText";
import DateTimeHelper from "../../utils/DateTimeHelper";
import AppUtils, {IS_LOCATION_REQUIRED} from "../../utils/AppUtils";
import {ImageIcon, SNACKBAR_AUTO_HIDE_DURATION} from "../commons/ViewHelper";
import {getPathForActivity, PathPlays} from "src/js/components/routes/NavHelper";
import auth from "src/js/utils/auth";
import FieldSpace from "src/js/components/commons/FieldSpace";
import ApiHelper from "src/js/utils/ApiHelper";

const ACTIONS_OFFER_VIEW_WIDTH = 86;
const ACTIONS_VIEW_WIDTH = 118;

const alignDir = 'left';

const useStyles = (theme) => ({
  gridItemsWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    maxWidth: 1820,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 8,
      paddingRight: 8,
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 4,
      paddingRight: 4,
    },
  },
  gridItems: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  cardImageOverlay: {
    borderRadius: BORDER_RADIUS,
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    marginRight: 12,
    width: '62%',
    height: '100%'
  },
  cardItemActionWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: ACTIONS_VIEW_WIDTH,
    width: ACTIONS_VIEW_WIDTH,
    backgroundColor: ColorField,
    borderRadius: BORDER_RADIUS,
    // borderTopRightRadius: BORDER_RADIUS,
    // borderBottomRightRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: -4,
  },
  cardItemActionWrapperOffers: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: ACTIONS_OFFER_VIEW_WIDTH,
    width: ACTIONS_OFFER_VIEW_WIDTH,
    backgroundColor: ColorField,
    borderRadius: BORDER_RADIUS,
    // borderTopRightRadius: BORDER_RADIUS,
    // borderBottomRightRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: -4,
  },
  cardItemActionWrapperV: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignDir,
    minHeight: 48,
    height: 48,
    // backgroundColor: ColorThemeYellowField,
    // borderRadius: BORDER_RADIUS,
    // borderTopRightRadius: BORDER_RADIUS,
    // borderBottomRightRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
  },
  cardItemContent: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: ACTIONS_VIEW_WIDTH + 8,
    minHeight: 50,
  },
  cardItemContentOffers: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: ACTIONS_OFFER_VIEW_WIDTH + 8,
    minHeight: 50,
  },
  cardItemContentXS: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'column',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    // paddingRight: 52,
    minHeight: 50,
  },
  cardItemContentPart1: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    minWidth: 150,
  },
  cardItemContentPart2: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 250,
    // marginTop: 8,
  },
  cardImage: {
    borderRadius: BORDER_RADIUS,
    backgroundColor: ColorField,
  },
  buttonAdd: {
    marginTop: CARD_SPACING/2,
    marginBottom: CARD_SPACING,
    fontWeight: 'bold',
    position: 'relative',
    overflow: 'hidden',
    padding: 8,
    paddingLeft: 24,
    paddingRight: 24,
  },
  messageBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 400,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 16,
  },
  menuItemBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 28
  },
  usageCardWrapper: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 1200,
  },
  usageCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    backgroundColor: ColorWhite,
    padding: 8,
    margin: 4,
    minHeight: 126,
    border: `1px solid rgba(0,0,0,0.05)`
  },
  usageCardImage: {
    width: 72,
    height: 72,
    borderRadius: BORDER_RADIUS,
    padding: 6,
  },
  actionButtonIcon: {
    border: '1px solid ' + ColorCardFieldSelected, width: 40, height: 40, backgroundColor: ColorCardFieldHover,
    '&:hover': {
      backgroundColor: ColorCardFieldSelected,
    },
  },
  itemTitleView: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    padding: 6,
  },
  cardHover: {
    position: 'absolute', top: 0, right: 0, bottom: 0, left: 0,
    borderRadius: BORDER_RADIUS,
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.04)',
    },
  }
});

export const ACTIVITY_TYPES_MODEL = [
  {'id': constants.activity.types.SMART_AD, 'name': <FormattedMessage id='activity.type.smartAd'/>},
  {'id': constants.activity.types.OFFER, 'name': <FormattedMessage id='activity.type.offer'/>},
  {'id': constants.activity.types.VOUCHER, 'name': <FormattedMessage id='activity.type.voucher'/>},
  // {'id': 8, 'name': locString('discountOffer')},
  {'id': constants.activity.types.QUESTION, 'name': <FormattedMessage id='activity.type.question'/>},
  // {'id': constants.activity.types.BUYER_OPINION, 'name': <FormattedMessage id='activity.type.buyerOpinion'/>},
  {'id': constants.activity.types.VISITOR_OPINION, 'name': <FormattedMessage id='activity.type.visitorOpinion'/>},
  {'id': constants.activity.types.PREDICTION, 'name': <FormattedMessage id='activity.type.prediction'/>},
  {'id': constants.activity.types.GUESS, 'name': <FormattedMessage id='activity.type.guess'/>},
  {'id': constants.activity.types.IDENTIFY_LOCATION, 'name': <FormattedMessage id='activity.type.identifyLocation'/>},
  {'id': constants.activity.types.SLIDES, 'name': <FormattedMessage id='activity.type.slides'/>},
  {'id': constants.activity.types.SHOWCASE_MENU, 'name': <FormattedMessage id='activity.type.showcaseMenu'/>},
  {'id': constants.activity.types.QUESTIONNAIRE, 'name': <FormattedMessage id='activity.type.questionnaire'/>},
  {'id': constants.activity.types.SURVEY, 'name': <FormattedMessage id='activity.type.survey'/>},
  {'id': constants.activity.types.EVENT, 'name': <FormattedMessage id='activity.type.event'/>},
  {'id': constants.activity.types.CHALLENGE, 'name': <FormattedMessage id='activity.type.challenge'/>},
  {'id': constants.activity.types.SOCIAL_CONTENT, 'name': <FormattedMessage id='activity.type.contentWriting'/>},
  {'id': constants.activity.types.LIKE_USER, 'name': <FormattedMessage id='activity.type.shareNLike'/>},
  {'id': constants.activity.types.COLLECT_STARS, 'name': <FormattedMessage id='activity.type.collectStar'/>},
  {'id': constants.activity.types.JACKPOT, 'name': <FormattedMessage id='activity.type.gameSlot'/>},
  {'id': constants.activity.types.GAME_GREEDY_SPIN, 'name': <FormattedMessage id='activity.type.gameGreedySpin'/>},
  {'id': constants.activity.types.GAME_BETTING_PIC, 'name': <FormattedMessage id='activity.type.gameBettingPic'/>},
  {'id': constants.activity.types.GAME_ROULETTE, 'name': <FormattedMessage id='activity.type.gameRoulette'/>},
  {'id': constants.activity.types.GAME_SPIN_N_DISCOVER, 'name': <FormattedMessage id='activity.type.gameSpinNDiscover'/>},
  {'id': constants.activity.types.GAME_FLIP_CARD, 'name': <FormattedMessage id='activity.type.gameFlipCard'/>},
  {'id': constants.activity.types.GAME_FIND_HIDDEN, 'name': <FormattedMessage id='activity.type.gameFindHidden'/>},
  {'id': constants.activity.types.GAME_MATCH_PAIR, 'name': <FormattedMessage id='activity.type.gameMatchPair'/>},
  {'id': constants.activity.types.GAME_MATCH_THREE, 'name': <FormattedMessage id='activity.type.gameMatchThree'/>},
  {'id': constants.activity.types.GAME_PUZZLE, 'name': <FormattedMessage id='activity.type.gamePuzzle'/>},
  {'id': constants.activity.types.GAME_PUZZLE_SLIDE, 'name': <FormattedMessage id='activity.type.gamePuzzleSlide'/>},
  {'id': constants.activity.types.GAME_TIC_TAC_TOE, 'name': <FormattedMessage id='activity.type.gameTicTacToe'/>},
  {'id': constants.activity.types.GAME_POKER, 'name': <FormattedMessage id='activity.type.gamePoker'/>},
  {'id': constants.activity.types.GAME_WHAC_A_MOLE, 'name': <FormattedMessage id='activity.type.gameWhacAMole'/>},
  {'id': constants.activity.types.GAME_BRAND_RACE, 'name': <FormattedMessage id='activity.type.gameBrandRace'/>},
];

const LOCATION_STATE_DONE = 0;
const LOCATION_STATE_NEED_PERMISSION_AGAIN = 2;
const LOCATION_STATE_IN_PROGRESS = 3;

export const GetViewForItem = React.memo((props) => {
  const {item, isLTR, classes, isXS, disabled, hideAction, onItemClicked} = props;
  const isTypeOffers = item.type === constants.activity.types.OFFER
    || item.type === constants.activity.types.DISCOUNT
    || item.type === constants.activity.types.VOUCHER;

  let type = null;
  ACTIVITY_TYPES_MODEL.forEach((activityType) => {
    if (activityType.id === item.type) {
      type = activityType.name;
    }
  });

  const onClick = () => {
    if (onItemClicked) {
      onItemClicked(item);
    }
  }

  let validityText = null;
  let validityTextEx = null;
  let validityColor = ColorTitleLite;
  const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(item.startAt);
  if (startDateDiff <= 0) {
    const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(item.endAt);
    if (endDateDiff <= 0) {
      validityText = <FormattedMessage id='generic.ended' />;
      validityColor = ColorOrange;
    } else {
      // validityText = <FormattedMessage id='generic.endingInTime' />;
      // validityColor = ColorActive;
      // validityTextEx = DateTimeHelper.getValidity(item.endAt);
      validityText = DateTimeHelper.getValidity(item.endAt, 'generic.endIn');
    }
  } else {
    // validityText = <FormattedMessage id='generic.startingInTime' />;
    // validityColor = ColorTitleLite;
    // validityTextEx = DateTimeHelper.getValidity(item.startAt);
    validityText = DateTimeHelper.getValidity(item.startAt, 'generic.startIn');
  }

  const viewButtom = (
    <div className={classes.viewColumn}>
      <Button
        disabled={disabled}
        className={isTypeOffers ? classes.funCardButtonColorConsume : null}
        style={{minWidth: 0, borderRadius: 8, marginLeft: isLTR ? 12 : 0, marginRight: !isLTR ? 12 : 0, opacity: hideAction ? 0 : 1}}
        disableElevation
        size={'small'}
        variant={'contained'}
        color={'primary'}
        onClick={onClick}>
        {ActivityHelper.getCtaTitle(item)}
      </Button>
    </div>
  );
  const colorCard = isXS ? ColorCardXS : ColorCard;
  const textShadowStyle = '0px 0px 2px '+ isXS ? ColorBackgroundXS : ColorBackground;
  const styleFlip = isLTR ? {} : {
    '-moz-transform': 'scaleX(-1)',
    '-webkit-transform': 'scaleX(-1)',
    '-o-transform': 'scaleX(-1)',
    'transform': 'scaleX(-1)',
    '-ms-filter': 'fliph',
    'filter': 'fliph',
  }
  const styleOverlayGradientPosition = isLTR ? {right: 0} : {left: 0};

  let imageUrl = item.imageUrl;
  if (!isTypeOffers && item.rewardImageUrl && (!item.imageUrl || item.imageUrl === ApiHelper.getActivityDefaultImageUrl(item.type, item.subType, item.gameInfo))) {
    imageUrl = item.rewardImageUrl;
  }
  if (!imageUrl && item.type === constants.activity.types.EXTERNAL_GAMES) {
    imageUrl = item.gameInfo.imageUrl;
  }

  return (
    <Paper elevation={1} key={''+ item.id} className={classes.funCardItemWrapper}>
      <ButtonBase disabled={disabled} className={classes.funButtonBase} onClick={onClick}>
        <div className={classes.funCardItem} style={{backgroundColor: colorCard}}>
          {imageUrl ?
            <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'row', justifyContent: isLTR ? 'flex-end' : 'flex-start'}}>
              <img
                className={classes.funCardItemImage}
                src={imageUrl}
              />
              <div style={{position: 'absolute', top: 0, bottom: 0, width: '70%', background: 'linear-gradient(55deg, '+ colorCard +','+ colorCard +','+ AppUtils.colorWithAlpha(colorCard, 0) +','+ AppUtils.colorWithAlpha(colorCard, 0), ...styleOverlayGradientPosition, ...styleFlip}} />
            </div>
            : null
          }

          <div className={classes.flexColumnNoCenter} style={{position: 'relative', padding: 12, alignItems: isLTR ? 'flex-start' : 'flex-end'}}>
            <img
              className={classes.funCardBusinessImage}
              src={item.business.imageUrl}
            />
            <div className={classes.flexGrow} />
            <Space horizontalSpace={1}/>
            <AppText variant={'body1'} numberOfLines={3} color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} textAlign={'left'} style={{width: '60%', textShadow: textShadowStyle}}>{item.title}</AppText>
            <Space horizontal={2}/>
            <div className={classes.viewRowFullWidthNoCenter} style={{alignItems: 'flex-end'}}>
              {!isLTR ? viewButtom : null}
              <div className={classes.flexColumnNoCenter} style={{alignItems: isLTR ? 'flex-start' : 'flex-end'}}>
                <AppText numberOfLines={1} variant={'body2'} color={ColorTitleLite} textAlign={'left'} style={{width: '60%', textShadow: textShadowStyle}}>{item.business.name}</AppText>
                {!hideAction ?
                  <div className={classes.viewRow} style={{flex: .5, minWidth: 90, marginTop: 2}}>
                    {!isLTR && validityTextEx ?
                      <Typography variant={"caption"} className={classes.typoNormal} style={{color: validityColor, marginRight: 4}} align={'left'}>
                        {validityTextEx}
                      </Typography>
                      : null
                    }
                    <Typography variant={"caption"} className={classes.typoNormal} style={{color: validityColor}} align={'left'}>
                      {validityText}
                    </Typography>
                    {isLTR && validityTextEx ?
                      <Typography variant={"caption"} className={classes.typoNormal} style={{color: validityColor, marginLeft: 4}} align={'left'}>
                        {validityTextEx}
                      </Typography>
                      : null
                    }
                  </div>
                  : null
                }
              </div>
              {isLTR ? viewButtom : null}
            </div>
          </div>
          {isTypeOffers ?
            <div className={classes.funRewardMedalView}>
              <ImageIcon src={require('src/images/ic_reward_medal.png')} width={48} height={48} />
            </div>
            : null
          }
        </div>
        <div className={classes.cardHover}/>
      </ButtonBase>
    </Paper>
  );
});

const Cell = ({columnIndex, rowIndex, style, data}) => {
  const {items, canLoadMore, columnCount, spacingH, app, classes, isXS, onItemClicked} = data;
  const index = columnCount * rowIndex + columnIndex;
  if (index > items.length || (index === items.length && !canLoadMore)) {
    return <div style={style}>
      <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      </div>
    </div>
  }
  if (index === items.length) {
    return <div style={style}>
      <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <CircularProgress size={24} />
      </div>
    </div>
  }

  const spacing = CARD_SPACING/2;
  return <div style={style}>
    <div style={{width: '100%', height: '100%', padding: spacing, paddingLeft: columnIndex === 0 ? spacingH + spacing : spacing, paddingRight: columnIndex === columnCount - 1 ? spacingH + spacing : spacing}}>
      <GetViewForItem isXS={isXS} item={items[index]} isLTR={app.isLTR} classes={classes} onItemClicked={onItemClicked} />
    </div>
  </div>
};


class FunLists extends React.Component {

  constructor(props) {
    super(props);
    this.readOnly = !auth.isAuthenticated();

    this.fetchCounter = 0;
    this.geoLocation = null;
    this.isLocationPresent = LocationHelper.isLocationPresent();
    this.timeoutHandler = null;
    this.lastPath = this.props.history.location.pathname + this.props.history.location.hash;

    this.isCacheLoaded = false;
    this.isCacheMissLoaded = false;
    this.state = {
      windowWidth: window.appWidth,
      windowHeight: window.appHeight,
      searchText: '',
      localitySearch: '',
      listScrollOffset: 0,

      showStateChangeModal: false,
      showDeleteModal: false,
      activityData: null,
      isFetchInProgress: true,

      filters: {
        types: [],
        states: [],
        localityIds: [],
      },
      selectedFilters: [],
      filterObjs: {
        types: [],
        states: [],
        localityIds: [],
      },

      locationStatus: this.isLocationPresent ? LOCATION_STATE_IN_PROGRESS : LOCATION_STATE_DONE,
    };

    this.onRetryClicked = this.onRetryClicked.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.onClickClearSearch = this.onClickClearSearch.bind(this);
    this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleOnSelectChange = this.handleOnSelectChange.bind(this);
    this.removeSelectedFilter = this.removeSelectedFilter.bind(this);

    this.fetchLocalities = debounce(this.fetchLocalities, 400);
  }

  componentDidMount() {
    document.title = this.isShowingRewards() ? 'Rab7 | Won Rewards' : 'Rab7 | Play';

    this.fetchData(true, true); // load cache if present

    if (!IS_LOCATION_REQUIRED) {
      this.fetchData();
    } else {
      this.timeoutHandler = setTimeout(() => {
        this.timeoutHandler = null;
        this.fetchData();
      }, 3 * 1000);
      setTimeout(() => {
        this.fetchLocation();
      });
    }

    window.addEventListener('resize', this.onWindowResize);

    setTimeout(() => {
      changeBodyColor(this.props.isXS ? ColorBackgroundXS : ColorBackground);
    }, 100);
  }

  componentWillUnmount() {
    this.clearFetchTimeout();
    window.removeEventListener('resize', this.onWindowResize);
  }

  componentDidUpdate(prevProps) {
    const path = this.props.history.location.pathname + this.props.history.location.hash;
    if (this.lastPath !== path) {
      this.fetchData();
    }
  }

  onWindowResize = (event) => {
    // changeBodyColor(window.appWidth <= 600 ? ColorBackgroundXS : ColorBackground);
    this.setState({windowWidth: window.appWidth, windowHeight: window.appHeight});
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.funActivities.cacheMiss && !this.isCacheMissLoaded) {
      this.isCacheMissLoaded = true;
      // this.fetchData();
    } else if (nextProps.funActivities.cache && !this.isCacheLoaded) {
      this.props.resetCacheListData();
      this.isCacheLoaded = true;
      if (this.timeoutHandler) {
        this.clearFetchTimeout();
      }
      this.setState({isFetchInProgress: false, locationStatus: LOCATION_STATE_DONE}, () => {
        if (this.refList) {
          this.refList.scrollTo({scrollLeft: 0, scrollTop: nextProps.funActivities.scrollTo});
        }
      });
    }
    return true;
  }

  clearFetchTimeout() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  fetchLocation = () => {
    const showLoader = this.props.funActivities.paginated.data.length === 0;
    if (showLoader) {
      this.props.showGeoLocationLoading();
    }
    this.setState({locationStatus: LOCATION_STATE_IN_PROGRESS});
    LocationHelper.getLocation((location) => {
      this.geoLocation = location;
      this.clearFetchTimeout();
      this.setState({locationStatus: LOCATION_STATE_DONE});
      if (!this.isCacheLoaded) {
        this.fetchData();
        if (showLoader) {
          this.props.hideGeoLocationLoading();
        }
      }
    }, (errorCode) => {
        if (errorCode === LOCATION_TIMEOUT || this.isLocationDenied) {
          this.setState({locationStatus: LOCATION_STATE_DONE});
        } else {
          this.isLocationDenied = true;
          this.setState({locationStatus: LOCATION_STATE_NEED_PERMISSION_AGAIN});
        }
        if (!this.isCacheLoaded) {
          if (this.timeoutHandler) {
            this.clearFetchTimeout();
            this.fetchData();
          }
        }
        if (showLoader) {
          this.props.hideGeoLocationLoading();
        }
    });
  }

  onRetryClicked = () => {
    if (!IS_LOCATION_REQUIRED || this.geoLocation) {
      this.fetchData();
    } else {
      this.fetchLocation();
    }
  };

  onPlayClicked = () => {
    this.props.history.push(PathPlays);
  };

  fetchData(cache = false, cacheOnly = false, skipPush = true) {
    if (!cache) {
      logDebug('non cache called');
    }
    let searchText = null;
    let page = 1;
    let filterStatesText = null;
    let filterTypesText = null;
    let hash = this.props.history.location.hash;
    if (hash && hash.length > 0) {
      hash = hash.replace("#", "");
      const params = hash.split('&');
      if (params && params.length > 0) {
        params.forEach((param) => {
          if (param && param.length > 0) {
            const keyValues = param.split('=');
            if (keyValues && keyValues.length >= 0) {
              const key = keyValues[0];
              const value = keyValues.length >= 1 ? keyValues[1] : null;
              if (value && value.length > 0) {
                if (key === "s") {
                  searchText = value;
                } else if (key === "p") {
                  page = value;
                } else if (key === "fs") {
                  filterStatesText = value;
                } else if (key === "ft") {
                  filterTypesText = value;
                }
              }
            }
          }
        });
      }
    }
    let filters = null;
    let filterObjs = null;
    const newState = {};
    if (searchText || page > 1 || filterStatesText || filterTypesText) {
      if (searchText) {
        newState.searchText = searchText;
      }
      if (filterStatesText || filterTypesText) {
        filters = {
          types: [],
          states: [],
        }
        filterObjs = {
          types: [],
          states: [],
        }
        if (filterStatesText) {
          const filtersData = this.queryParamToFiltersData(filterStatesText, filtersUtil.getActivityStates())
          filters.states = filtersData.ids;
          filterObjs.states = filtersData.objs;
        }
        if (filterTypesText) {
          const filtersData = this.queryParamToFiltersData(filterTypesText, filtersUtil.getActivityTypes())
          filters.types = filtersData.ids;
          filterObjs.types = filtersData.objs;
        }
        newState.filters = filters;
        newState.filterObjs = filterObjs;
      }
      this.setState(newState);
    }

    this.fetchActivities(searchText, page, null, filters, cache, cacheOnly, skipPush);
  }

  queryParamToFiltersData(filterIdsText, filters, isNumeric = true) {
    const filterIds = [];
    const filterObjs = [];
    if (filterIdsText && filterIdsText.length > 0) {
      const lFilterIds = filterIdsText.split(',');
      if (lFilterIds && lFilterIds.length >= 0) {
        lFilterIds.forEach((filterId) => {
          if (filterId && filterId.length > 0) {
            if (filters) {
              filters.forEach((filter) => {
                if (isNumeric) {
                  filterId = parseInt(filterId);
                }
                if (filter.value === filterId) {
                  filterIds.push(filterId);
                  filterObjs.push(filter);
                }
              });
            }
          }
        });
      }
    }
    return {
      'ids': filterIds,
      'objs': filterObjs
    };
  }

  filterToQueryParam(filterIds, filterKey) {
    if (filterIds && filterIds.length > 0) {
      return filterKey +'=' + implode(',', filterIds);
    }
    return null;
  }

  isShowingRewards() {
    const {history} = this.props;
    const path = get(history, 'location.pathname');
    return path.startsWith('/wons');
  }

  getCampaignUsageType() {
    const {history} = this.props;
    const path = get(history, 'location.pathname');
    if (path.startsWith('/marketingCampaigns')) {
      return constants.activity.usageTypes.MARKETING;
    }
    if (path.startsWith('/loyaltyCampaigns')) {
      return constants.activity.usageTypes.LOYALTY;
    }
    if (path.startsWith('/educationCampaigns')) {
      return constants.activity.usageTypes.EDUCATION;
    }
    if (path.startsWith('/trainingCampaigns')) {
      return constants.activity.usageTypes.TRAINING;
    }
    if (path.startsWith('/socialCampaigns')) {
      return constants.activity.usageTypes.SOCIAL;
    }
    if (path.startsWith('/influencerCampaigns')) {
      return constants.activity.usageTypes.INFLUENCER;
    }
    return 0;
  }

  getNoItemsMessageId() {
    if (this.isShowingRewards()) {
      return 'activity.noRewardsWonMessage';
    }
    if (IS_LOCATION_REQUIRED && !this.geoLocation) {
      return 'list.noCampaignsFoundNoLocation';
    }
    if (this.readOnly) {
      return 'list.noCampaignsFoundNoLogin';
    }
    return 'list.noCampaignsFound';
  }

  getNoMoreItemsMessage() {
    if (this.isShowingRewards()) {
      return 'list.noMoreRewardsFound';
    }
    return 'list.noMoreCampaignsFound';
  }

  render() {
    const {app, classes, isLoading, funActivities, isXS, user} = this.props;
    const {locationStatus, isFetchInProgress, windowWidth, windowHeight, listScrollOffset} = this.state;
    const isDrawerHidden = windowWidth < 1080;

    // if (isLoading) {
    //   return null;
    // }
    // if (funActivities.isFetchInProgress && funActivities.paginated.data.length === 0) {
    //   return <div className={classes.viewLoading} style={{left: app.isLTR && !isDrawerHidden ? DRAWER_WIDTH : 0, right: app.isLTR && !isDrawerHidden ? 0 : DRAWER_WIDTH}}>
    //     <CircularProgress />
    //   </div>;
    // }
    const showMessage = (!isFetchInProgress || funActivities.errMsg) && funActivities.paginated.data.length === 0 && funActivities.paginated.totalSize === 0;
    let messageId = null;
    let showRetry = false;
    let showJumpIn = false;
    if (funActivities.paginated.data.length === 0 && (!IS_LOCATION_REQUIRED || locationStatus !== LOCATION_STATE_IN_PROGRESS)) {
      if (funActivities.errMsgF) {
        messageId = funActivities.errMsgF;
        showRetry = true;
      } else if (!isLoading) {
        if (funActivities.paginated.totalSize > 0) {
          messageId = this.getNoMoreItemsMessage();
        } else {
          showRetry = true;
          showJumpIn = this.isShowingRewards();
          messageId = this.getNoItemsMessageId();
        }
      }
    }

    let locationMessageId = null;
    let locationMessageValues = null;
    let helpEnableLocationUrl = app.isLTR ? HELP_ENABLE_LOCATION_URL : HELP_ENABLE_LOCATION_AR_URL;
    const appConfigsLocation = user && user.appConfigs ? user.appConfigs.location : true;
    if (IS_LOCATION_REQUIRED && !this.geoLocation && !isLoading && !messageId && !appConfigsLocation && !this.isShowingRewards()) {
      if (locationStatus === LOCATION_STATE_IN_PROGRESS) {
        locationMessageId = 'profile.locationInProgress';
      } else if (locationStatus === LOCATION_STATE_NEED_PERMISSION_AGAIN) {
        locationMessageId = 'activity.locationDenied';
        locationMessageValues = {value: helpEnableLocationUrl};
      } else if (locationStatus === LOCATION_STATE_DONE) {
        if (this.isLocationDenied) {
          locationMessageId = 'activity.locationDenied';
          locationMessageValues = {value: helpEnableLocationUrl};
        } else {
          locationMessageId = 'activity.locationTimeout';
        }
      }
    }
    let locationMessage = null;
    if (locationMessageId) {
      if (locationMessageValues) {
        locationMessage = <FormattedHTMLMessage id={locationMessageId} values={locationMessageValues} />;
      } else {
        locationMessage = <FormattedHTMLMessage id={locationMessageId} />;
      }
    }

    const itemsCount = funActivities.paginated.data.length;

    const windowWidthEff = windowWidth - (isDrawerHidden ? 0 : DRAWER_WIDTH); // - (isXS ? 8 : 16);
    const maxContentWidth = Math.min(windowWidthEff, CONTENT_MAX_WIDTH_PLAY);
    const eItemWidth = this.getItemWidth(maxContentWidth- (isDrawerHidden ? 16 : 32)); // isXS ? Math.min(windowWidthEff, 416) : 416;
    const eItemHeight = Math.max(Math.ceil(eItemWidth/2), 216);

    const columnCount = Math.max(1, Math.floor((maxContentWidth / eItemWidth)));
    let rowCount = Math.ceil(itemsCount / columnCount);
    if (funActivities.paginated.canLoadMore) {
      rowCount = rowCount + 1;
    }

    const tabHeight = isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT;
    const bottomTabHeight = IS_BOTTOM_TAB_PRESENT && PathHelper.isBottomTabPresent(isDrawerHidden, history) ? (isXS ? BOTTOM_BAR_HEIGHT_XS : BOTTOM_BAR_HEIGHT) : 0;
    const gridWidth = windowWidthEff;
    const gridHeight = windowHeight - tabHeight - bottomTabHeight - (locationMessageId ? 45 : isXS ? 6 : 8);
    const spacingH = Math.max(0, Math.floor((windowWidthEff - (columnCount * eItemWidth)) / 2));

    const spaceHLocationText = spacingH;
    return (
      <div className={classes.flexColumn} style={{marginTop: isXS ? 4 : 8, position: 'relative'}}>
        <HeaderTitleView isLTR={app.isLTR} isDrawerHidden={isDrawerHidden} isXS={isXS} titleId={this.isShowingRewards() ? 'menu.rewardsWon' : 'menu.play'}/>
        <AppInstall isLTR={app.isLTR} />
        {/*<LanguageDialog />*/}

        {isFetchInProgress ?
          <div className={classes.viewLoading} style={{left: !isDrawerHidden ? app.isLTR ? DRAWER_WIDTH : 0 : 0, right: !isDrawerHidden ? app.isLTR ? 0 : DRAWER_WIDTH : 0}}>
            <CircularProgress />
          </div>
          : null
        }
        {!isFetchInProgress ?
          <div className={classes.viewColumnFullWidth}>
            {locationMessageId ?
              <div className={classes.viewColumnFullWidthNoCenter}>
                <div className={classes.viewRowFullWidth}>
                  <div className={classes.viewRow} style={{margin: 8, marginTop: isXS ? 4 : 0, borderRadius: BORDER_RADIUS}}>
                    <div className={classes.viewColumn} style={{marginLeft: spaceHLocationText, marginRight: spaceHLocationText}}>
                      <div className={classes.viewRow}>
                        <TextView fontSizeN={isXS ? 15.2 : 16} textAlign={'left'} variant={'body2'} color={ColorSubTitle} fontWeight={FontWeightMedium}>
                          {locationMessage}
                        </TextView>
                        <Space verticalSpace={1}/>
                        {locationStatus === LOCATION_STATE_IN_PROGRESS ?
                          <div style={{height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <CircularProgress size={20} />
                          </div>
                          :
                          <Button
                            color="primary"
                            size={'small'}
                            disableElevation
                            variant={'contained'}
                            onClick={this.fetchLocation}>
                            <TextView color={ColorWhite} variant={'body2'} fontWeight={FontWeightMedium}>
                              <FormattedMessage id={'location.refresh'} />
                            </TextView>
                          </Button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null
            }

            <div style={{height: listScrollOffset > 0 ? 1 : 0, marginTop: listScrollOffset > 0 ? -1 : 0, width: '100%', backgroundColor: 'rgba(0,0,0,0.1)'}} />
            <div className={classes.gridItemsWrapper}>
              {messageId == null ?
                <div className={classes.viewColumnFullWidth}>
                  {/*<div style={{ height: windowHeight, width: windowWidth, backgroundColor: '#FF0000' }}>*/}
                  {/*  <AutoSizer>*/}
                  {/*    {({ height, width }) => {*/}
                  {/*      logDebug('debugNow-AutoSizer', {height, width});*/}
                  {/*      return*/}
                  <InfiniteLoader
                    style={{overflow: 'hidden'}}
                    isItemLoaded={index => {
                      return index < Math.ceil(funActivities.paginated.data.length / columnCount)}
                    }
                    itemCount={Math.ceil(itemsCount/columnCount)+1}
                    loadMoreItems={() => {
                      return new Promise(resolve => {
                          const {searchText, filters} = this.state;
                          this.fetchActivities(searchText, funActivities.paginated.page + 1, null, filters, false, false, true, () => {
                            resolve();
                          });
                        }
                      );
                    }}
                    threshold={Math.floor(15/columnCount)}>
                    {({onItemsRendered, ref}) => (
                      <VariableSizeGrid
                        ref={(refL) => {
                          this.refList = refL;
                          ref(refL);
                        }}
                        key={windowWidth +'-'+ windowHeight}
                        align={'center'}
                        onItemsRendered={gridProps => {
                          onItemsRendered({overscanStartIndex: gridProps.overscanRowStartIndex, overscanStopIndex: gridProps.overscanRowStopIndex, visibleStartIndex: gridProps.visibleRowStartIndex, visibleStopIndex: gridProps.visibleRowStopIndex})
                        }}
                        onScroll={this.onGridScroll}
                        width={gridWidth}
                        height={gridHeight}
                        columnCount={columnCount}
                        rowCount={rowCount}
                        columnWidth={index => this.getCellWidth(index, columnCount, eItemWidth, spacingH)}
                        rowHeight={index => eItemHeight}
                        itemData={{
                          items: funActivities.paginated.data,
                          canLoadMore: funActivities.paginated.canLoadMore,
                          columnCount,
                          app,
                          isXS,
                          classes,
                          spacingH,
                          onItemClicked: this.onItemClicked
                        }}>
                        {Cell}
                      </VariableSizeGrid>
                    )}
                  </InfiniteLoader>
                  {/*    }}*/}
                  {/*  </AutoSizer>*/}
                  {/*</div>*/}
                </div>
                : null
              }
            </div>

            {messageId != null && (
              <div className={classes.containerError}>
                <Typography align={'center'} variant="subtitle1" color={'textSecondary'} className={classes.typoMedium}>
                  {<FormattedHTMLMessage id={messageId} />}
                </Typography>
                <div className={classes.viewRow}>
                  {showRetry ?
                    <Button
                      disableElevation={true}
                      style={{marginTop: FIELD_SPACE}}
                      size={isXS ? 'small' : 'medium'}
                      variant={showJumpIn ? 'outlined' : 'contained'}
                      color={showJumpIn ? "secondary" : "primary"}
                      onClick={this.onRetryClicked}>
                      {<FormattedMessage id='retry' />}
                    </Button>
                    : null
                  }
                  {showJumpIn ?
                    <React.Fragment>
                      <FieldSpace multiplier={0.75} vertical={true}/>
                      <Button
                        disableElevation={true}
                        style={{marginTop: FIELD_SPACE}}
                        size={isXS ? 'small' : 'medium'}
                        variant={'contained'}
                        color={"primary"}
                        onClick={this.onPlayClicked}>
                        {<FormattedMessage id='ctaPlay' />}
                      </Button>
                    </React.Fragment>
                    : null
                  }
                </div>
              </div>
            )}

            {this.renderSnackBarReducer()}
            {this.renderSnackBar()}
            {this.getDialogView()}
          </div>
          : null
        }
      </div>
    );
  }

  getDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    const {
      title,
      message,
      content,
      positiveText,
      onPositiveClicked,
      neutralText,
      onNeutralClicked,
    } = dialogInfo;
    return (
      <DialogView
        classes={classes}
        show={showDialog}
        title={title}
        message={message}
        content={content}
        positiveText={positiveText}
        onPositiveClicked={onPositiveClicked}
        neutralText={neutralText}
        onNeutralClicked={onNeutralClicked}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog() {
    this.setState({showDialog: false, dialogInfo: null});
  }

  handleAlertClose = () => {
    this.props.resetActivitiesError();
  };

  renderSnackBarReducer() {
    const {funActivities} = this.props;
    const showErrorSnack = funActivities.errMsg && (!(typeof funActivities.errMsg === 'string' || funActivities.errMsg instanceof String) || funActivities.errMsg.length > 0);
    const showSuccessSnack = funActivities.successMsg && (!(typeof funActivities.successMsg === 'string' || funActivities.successMsg instanceof String) || funActivities.successMsg.length > 0);
    const showSnack = showErrorSnack || showSuccessSnack;
    const severity = showErrorSnack ? "error" : "success";
    const message = showErrorSnack ? funActivities.errMsg : funActivities.successMsg;
    return (
      <Snackbar open={showSnack} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={this.handleAlertClose}>
        <MuiAlert severity={severity} onClose={this.handleAlertClose} elevation={6} variant="filled">
          {message}
        </MuiAlert>
      </Snackbar>
    );
  }

  renderSnackBar() {
    const {snackbarMessageId, snackbarType} = this.state;
    const onClose = () => {
      this.setState({snackbarMessageId: null, snackbarType: null});
    };
    return (
      <Snackbar open={snackbarMessageId != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
        <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
          {snackbarMessageId ? <FormattedMessage id={snackbarMessageId} /> : null}
        </MuiAlert>
      </Snackbar>
    );
  }

  handleMultiSelect(name, values) {
    const {filterObjs, filters} = this.state;
    if (!values) {
      values = [];
    }
    const newFilters = cloneDeep(filters);
    const newFilterObjs = cloneDeep(filterObjs);
    newFilters[name] = [];
    newFilterObjs[name] = [];
    values.forEach((item) => {
      newFilters[name].push(item.value);
      newFilterObjs[name].push(item);
    });

    this.setState({
      filters: newFilters,
      filterObjs: newFilterObjs,
      selectedFilters: [
        ...this.state.selectedFilters,
        {type: name, name: name, value: newFilters[name]}
      ]
    }, () => {
      const {searchText, filters} = this.state;
      this.fetchActivities(searchText, 1, null, filters)
    });
  }

  handleOnSelectChange = (e) => {
    const {
      target: {
        name,
        value
      }
    } = e;
    let {
      filters,
      searchText,
    } = this.state;
    const optionText = e.target.options[e.target.selectedIndex].text;

    if (filters[name].indexOf(value) >= 0) {
      return;
    }

    filters = cloneDeep(filters);
    filters[name].push(value);

    this.setState({
      filters,
      selectedFilters: [
        ...this.state.selectedFilters,
        { type: name, name: optionText, value: value }
      ]
    }, () => {
      this.fetchActivities(searchText, 1, null, filters)
    });
  }

  getItemWidth(windowWidth) {
    let columnsPossible = 1;
    for (let i = 1; i <= 5; i++) {
      if (windowWidth / (i+1) < 364) {
        break;
      }
      columnsPossible++;
    }
    const maxWidthPossible = this.props.isSM ? 550 : 437;
    return Math.min(Math.max(windowWidth / columnsPossible, 350), maxWidthPossible);
  }

  getCellWidth = (index, columnCount, eItemWidth, spacingH) => {
    if (index % columnCount === 0 && index % columnCount === columnCount - 1) {
      return eItemWidth + 2 * spacingH;
    } else if (index % columnCount === 0) {
      return eItemWidth + spacingH;
    } else if (index % columnCount === columnCount - 1) {
      return eItemWidth + spacingH;
    }
    return eItemWidth;
  }

  onItemClicked = (item) => {
    this.pushTo({
      pathname: getPathForActivity(item) +'/'+ item.id,
      search: '?cgb=1',
      state: {canGoBack: true}
    }, true);
  };

  fetchLocalities = (value) => {
    const { fetchLocalities } = this.props;

    if (value) {
      fetchLocalities(value);
    }
  }

  handleSearchChangeLocalities = (event, { newValue }) => {
    this.setState({ localitySearch: newValue });
  }

  renderSuggestion = (suggestion) => {
    return (
      <span>
        {suggestion.name}
      </span>
    );
  }

  onSuggestionsFetchRequestedLocalities = ({ value }) => {
    this.fetchLocalities(value);
  }

  onSuggestionsClearRequestedLocalities = () => {
    const { resetLocalitiesData } = this.props;

    this.fetchLocalities.cancel();
    resetLocalitiesData();
  }
  onSuggestionSelectedLocality = (event, { suggestion }) => {
    const value = suggestion.id;
    let {
      searchText,
      filters
    } = this.state;

    if (filters.localityIds.indexOf(value) >= 0) {
      return;
    }

    filters = cloneDeep(this.state.filters);
    filters.localityIds.push(value);

    this.setState({
      localitySearch: '',
      filters: filters,
      selectedFilters: [...this.state.selectedFilters, { type: 'localityIds', name: suggestion.name, value }]
    }, () => {
      this.fetchActivities(searchText, 1, null, filters);
    });
  }

  removeSelectedFilter(selectedFilter) {
    const filters = cloneDeep(this.state.filters);

    this.setState({
      selectedFilters: filter(this.state.selectedFilters, (filter) => {
        return (filter.type !== selectedFilter.type) || (filter.name !== selectedFilter.name);
      })
    });

    filters[selectedFilter.type] = filter(filters[selectedFilter.type], (value) => {
      return value !== selectedFilter.value;
    });

    this.setState({ filters }, () => {
      this.fetchActivities(this.state.searchText, 1, null, filters);
    });
  }

  onChangeSearchInput(e) {
    this.setState({
      searchText: e.target.value
    });
  }

  handleKeyPress(e) {
    const {searchText, filters} = this.state;
    // Enter key
    if(e.keyCode == 13) {
      this.fetchActivities(searchText, 1, null, filters);
    }
  }

  onClickSearch() {
    const {searchText, filters} = this.state;
    this.fetchActivities(searchText, 1, null, filters);
  }

  onClickClearSearch() {
    this.setState({searchText: ''}, () => {
      const { searchText, filters } = this.state;
      this.fetchActivities(searchText, 1, null, filters);
    });
  }

  isItemReward(item) {
    return item.type === constants.activity.types.OFFER
      || item.type === constants.activity.types.DISCOUNT
      || item.type === constants.activity.types.VOUCHER;
  }

  onClickDeleteItem = (item) => {
    this.onCloseMore();
    this.setState({
      showDeleteModal: true,
      activityData: item
    });
  };

  onClickMore = (item, origin) => {
    this.setState({showMenuId: item.id, showMenuElement: origin.target});
  };

  onCloseMore = () => {
    this.setState({showMenuId: null, showMenuElement: null});
  };

  onClickCopyLink(row) {
    copyTextToClipboard(`https://api.rab7.com/a/${row.id}`);

    toast(() => (
      <FormattedHTMLMessage id='admin.notification.link_copied' values={row} />
    ), {
      containerId: 'toastContainer',
    });
  }

  onGridScroll = ({horizontalScrollDirection, scrollLeft, scrollTop, scrollUpdateWasRequested, verticalScrollDirection}) => {
    const {listScrollOffset} = this.state;
    if (!listScrollOffset && scrollTop || listScrollOffset && !scrollTop) {
      this.setState({listScrollOffset: scrollTop});
    } else {
      this.state.listScrollOffset = scrollTop;
    }
  };

  handleTableChange = (type, { page }) => {
    const {funActivities} = this.props;
    const {searchText, filters} = this.state;
    // const skipPush = funActivities.paginated && funActivities.paginated.page && page === funActivities.paginated.page - 1;
    this.fetchActivities(searchText, page, null, filters);
  }

  pushTo(path, cacheCurrent = false) {
    if (cacheCurrent) {
      this.props.cacheListData(this.state.listScrollOffset, FETCH_CACHE_FUN_ACTIVITIES, this.props.funActivities.paginated);
    }

    history.push(path);
  }

  fetchActivities(search, page, perPage, filters, cache = false, cacheOnly = false, skipPush = false, onLoaded = null) {
    let filterTypes = null;
    let effTypes = this.isShowingRewards()
      ? [constants.activity.types.OFFER,
        constants.activity.types.VOUCHER,
        constants.activity.types.DISCOUNT,
      ] : [constants.activity.types.SMART_AD,
        constants.activity.types.QUESTION,
        constants.activity.types.BUYER_OPINION,
        constants.activity.types.VISITOR_OPINION,
        constants.activity.types.CHALLENGE,
        constants.activity.types.PREDICTION,
        constants.activity.types.JACKPOT,
        constants.activity.types.GAME_FLIP_CARD,
        constants.activity.types.EVENT,
        constants.activity.types.LIKE_USER,
        constants.activity.types.COLLECT_STARS,
        constants.activity.types.GUESS,
        constants.activity.types.GAME_ROULETTE,
        constants.activity.types.SOCIAL_CONTENT,
        constants.activity.types.GAME_SPIN_N_DISCOVER,
        constants.activity.types.GAME_FIND_HIDDEN,
        constants.activity.types.GAME_GREEDY_SPIN,
        constants.activity.types.GAME_BETTING_PIC,
        constants.activity.types.GAME_MATCH_PAIR,
        constants.activity.types.GAME_TIC_TAC_TOE,
        constants.activity.types.QUESTIONNAIRE,
        constants.activity.types.SURVEY,
        constants.activity.types.GAME_MATCH_THREE,
        constants.activity.types.GAME_PUZZLE,
        constants.activity.types.GAME_WHAC_A_MOLE,
        constants.activity.types.GAME_BRAND_RACE,
        constants.activity.types.GAME_POKER,
        constants.activity.types.IDENTIFY_LOCATION
      ];
    if (filters && filters.types && filters.types.length > 0) {
      filters.types = filters.types.filter(value => effTypes.includes(value));
    } else {
      filterTypes = effTypes;
    }

    let params = [];
    if (search && search.length > 0) {
      params.push('s=' + search);
    }
    if (page > 1) {
      params.push('p=' + page);
    }
    if (filters) {
      let filterKeyValue = this.filterToQueryParam(filters.states, 'fs');
      if (filterKeyValue) {
        params.push(filterKeyValue);
      }
      filterKeyValue = this.filterToQueryParam(filters.types, 'ft');
      if (filterKeyValue) {
        params.push(filterKeyValue);
      }
    }
    // if (!skipPush) {
    //   let hash = '#';
    //   if (params && params.length > 0) {
    //     let count = 0;
    //     params.forEach((param) => {
    //       if (count > 0) {
    //         hash += '&';
    //       }
    //       hash += param;
    //       count++;
    //     });
    //   }
    //   history.push(hash);
    // }

    // set default activity types & usage
    let newFilters = cloneDeep(filters);
    if (filterTypes) {
      if (!newFilters) {
        newFilters = {};
      }
      newFilters.types = filterTypes;
    }
    newFilters.usageTypes = this.getCampaignUsageType();

    this.lastPath = this.props.history.location.pathname + this.props.history.location.hash;

    const {funActivities} = this.props;
    page = page || funActivities.paginated.page;
    perPage = perPage || funActivities.paginated.perPage;

    if (page === 1) {
      this.setState({isFetchInProgress: true});
    }

    if (cache) {
      this.props.fetchCacheActivities();
    } else if (!cacheOnly) {
      const onResult = () => {
        this.fetchCounter--;
        if (this.fetchCounter === 0) {
          this.setState({isFetchInProgress: false});
          if (onLoaded) {
            onLoaded();
          }
        }
      };
      this.fetchCounter++;
      if (this.isShowingRewards()) {
        this.props.fetchRewards(this.geoLocation, page, perPage).then(onResult).catch(onResult);
      } else {
        if (this.readOnly) {
          this.props.fetchOpenActivities(this.geoLocation, page, perPage).then(onResult).catch(onResult);
        } else {
          this.props.fetchActivities(this.geoLocation, page, perPage).then(onResult).catch(onResult);
        }
      }
    }
  }
}

FunLists.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object,
  funActivities: PropTypes.object,
  isLoading: PropTypes.bool,
  localities: PropTypes.array,
  fetchHelp: PropTypes.func,
  fetchActivities: PropTypes.func,
  resetActivitiesError: PropTypes.func,
  fetchLocalities: PropTypes.func,
  resetLocalitiesData: PropTypes.func,
  showActivityLinkCopiedSnackbar: PropTypes.func,
};

FunLists.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  const {funActivities, localities} = state.admin;
  return {
    app: state.app,
    user: state.admin.user,
    isLoading: state.isLoading,
    funActivities,
    localities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchHelp: (id) => dispatch(fetchHelp(id)),
    showActivityLinkCopiedSnackbar: (id) => dispatch(showActivityLinkCopiedSnackbar(id)),
    fetchCacheActivities: () => dispatch(fetchCacheActivities()),
    fetchOpenActivities: (geoLocation, page, perPage) => dispatch(fetchOpenActivities(geoLocation, page, perPage)),
    fetchActivities: (geoLocation, page, perPage) => dispatch(fetchActivities(geoLocation, page, perPage)),
    fetchRewards: (geoLocation, page, perPage) => dispatch(fetchRewards(geoLocation, page, perPage)),
    resetActivitiesError: () => dispatch(resetActivitiesError()),
    showGeoLocationLoading: () => dispatch(showGeoLocationLoading()),
    hideGeoLocationLoading: () => dispatch(hideGeoLocationLoading()),
    cacheListData: (scrollPosition, type, data) => dispatch(cacheListData(scrollPosition, type, data)),
    resetCacheListData: () => dispatch(resetCacheListData()),

    fetchLocalities: (search) => dispatch(fetchLocalities(search)),
    resetLocalitiesData: () => dispatch(resetLocalitiesData),
  };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isSM', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
  ])(FunLists))
);
